import { SSN_EMPTY_MASK } from 'utility/constants';
import { licenseNumberRegex, ssnRegex } from 'utility/regex';

export const HsmvDemoCheckValidatorFactory = () => {
  const requiredDriverLicenseNumberText = 'Either Driver\'s License Number or SSN must be entered';
  const requiredSsnText = 'Either Driver\'s License Number or SSN must be entered';
  const requiredDOBText = 'The DOB field is required';
  const requiredJustificationText = 'The Justification field is required';

  return (values) => {
    const validators = {
      requiredDriversLicenseNumber: values.driversLicenseNumber || (values.ssn && values.ssn !== SSN_EMPTY_MASK) ? '' : requiredDriverLicenseNumberText,
      requiredSSN: values.driversLicenseNumber || (values.ssn && values.ssn !== SSN_EMPTY_MASK) ? '' : requiredSsnText,
      requiredDOB: values.dob ? '' : requiredDOBText,
      requiredJustification: values.justification ? '' : requiredJustificationText,

      formatDriversLicenseNumber: (values.driversLicenseNumber ? (licenseNumberRegex.test(values.driversLicenseNumber) ? '' : 'License number not in correct format') : ''),
      formatSSN: ((values.ssn && values.ssn !== SSN_EMPTY_MASK) ? (ssnRegex.test(values.ssn) ? '' : 'SSN not in correct format') : ''),
      formatDOB: (values.dob ? (Math.floor((new Date().getTime() - new Date(values.dob).getTime())) > 0 && new Date(values.dob).getFullYear() >= 1900) ? '' : 'Enter a valid Date of Birth' : ''),
    };
    return validators;
  };
};
